import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { staffApi } from '../../lib/http';
import { PortalButton, PortalCard, PortalEmpty, PortalInput, PortalSelect, PortalStatus } from '../../components/portal/PortalElements';

export default function StaffCheckins() {
  const today = new Date().toISOString().slice(0, 10);
  const [search, setSearch] = useState('');
  const [date, setDate] = useState(today);
  const [sort, setSort] = useState('desc');
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, page: 1, limit: 10 });

  async function loadCheckins() {
    try {
      const response = await staffApi.get('/staff/checkins', {
        params: { search, date, sort, page, limit: 10 },
      });
      setData(response.data);
    } catch (error) {
      toast.error(error.message || 'Unable to load check-ins.');
    }
  }

  useEffect(() => {
    loadCheckins();
  }, [search, date, sort, page]);

  const totalPages = Math.max(1, Math.ceil((data.total || 0) / 10));

  return (
    <div className="portal-stack">
      <PortalCard>
        <div className="portal-filters">
          <PortalInput label="Search" value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Booking or guest" />
          <PortalInput label="Date" type="date" value={date} onChange={(event) => setDate(event.target.value)} />
          <PortalSelect label="Sort" value={sort} onChange={(event) => setSort(event.target.value)}>
            <option value="desc">Newest first</option>
            <option value="asc">Oldest first</option>
          </PortalSelect>
          <PortalButton variant="secondary" onClick={() => { setSearch(''); setDate(today); setSort('desc'); setPage(1); }}>
            Reset
          </PortalButton>
        </div>
      </PortalCard>

      <PortalCard>
        {(data.items || []).length ? (
          <>
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Booking</th>
                    <th>Guest</th>
                    <th>Table Preference</th>
                    <th>Mobile</th>
                    <th>Guests</th>
                    <th>Checked in by</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.items.map((item) => (
                    <tr key={`${item.bookingId}-${item.checkedInAt}`}>
                      <td>{item.time}</td>
                      <td>{item.bookingId}</td>
                      <td>{item.customerName}</td>
                      <td>{item.tablePreference || '-'}</td>
                      <td>{item.phone}</td>
                      <td>{item.pax}</td>
                      <td>{item.checkedInBy}</td>
                      <td><PortalStatus>{item.status}</PortalStatus></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="portal-action-row">
              <PortalButton variant="secondary" disabled={page <= 1} onClick={() => setPage((current) => Math.max(1, current - 1))}>
                Previous
              </PortalButton>
              <span className="portal-muted">Page {page} of {totalPages}</span>
              <PortalButton variant="secondary" disabled={page >= totalPages} onClick={() => setPage((current) => Math.min(totalPages, current + 1))}>
                Next
              </PortalButton>
            </div>
          </>
        ) : (
          <PortalEmpty title="No check-ins found" body="Try another date or wait for the first guest to arrive." />
        )}
      </PortalCard>
    </div>
  );
}
